import { z } from 'zod'

export const loginGetCaptchaSchema = z.object({
  /** 驗證碼 */
  captchaCode: z.string(),
  /** 驗證碼token	*/
  captchaToken: z.string(),
  /** 驗證碼圖片 */
  captchaImage: z.string(),
  /** 驗證碼語音 */
  captchaVoice: z.string()
})

export interface LoginGetCaptcha
  extends z.infer<typeof loginGetCaptchaSchema> {}

export class LoginGetCaptcha {
  constructor() {
    return {
      captchaCode: '',
      captchaToken: '',
      captchaImage: '',
      captchaVoice: ''
    }
  }
}
